import { useTranslation } from "react-i18next";

import { formatRating } from "@/modules/achievements/utils/formatRating";

import { ParsedLevel } from "./useGetLevelsQuery";

const translationNamespace = "pages/LevelsPage";

export const useMapLevelsRequirements = (
  levels?: ParsedLevel[],
  currentUserLevel?: number | null
) => {
  const { t } = useTranslation(translationNamespace);

  if (!levels || !levels.length) return;

  return levels.map(({ required, achieved, order }) => {
    const requirements = {
      points: {
        isCompleted: required.pointsNumber <= achieved.pointsNumber,
        label: t("{{pointsNumber}} PT", {
          pointsNumber: required.pointsNumber,
        }),
      },
      seniority: {
        isCompleted: required.seniorityDays <= achieved.seniorityDays,
        label: t("seniority", {
          count: required.seniorityValue,
          context: required.seniorityUnit.toLowerCase(),
        }),
      },
      rating: {
        isCompleted: required.averageRating <= achieved.averageRating,
        label: t("Rating {{rating}}", {
          rating: formatRating(required.averageRating),
        }),
      },
      ...(required.tutorialCount && {
        tutorials: {
          isCompleted: required.tutorialCount <= achieved.tutorialCount,
          label: t("tutorials", {
            count: required.tutorialCount,
          }),
        },
      }),
    };

    const requirementsAchievedCount = Object.values(requirements).filter(
      (requirement) => requirement.isCompleted
    ).length;

    const requirementsCount = Object.keys(requirements).length;

    const progress = (requirementsAchievedCount / requirementsCount) * 100;

    const areAllRequirementsCompleted =
      requirementsAchievedCount === requirementsCount;

    const isLevelActive =
      currentUserLevel || currentUserLevel === 0
        ? currentUserLevel >= order
        : false;

    return {
      order,
      isLevelActive,
      requirements,
      progress,
      areAllRequirementsCompleted,
    };
  });
};
